import * as React from "react";

import "./ChipButton.scss";
import {Button, delay} from "@vebox/etui-core";
import {height} from "@vebox/etui-system";

export interface ChipButtonColor {
    background: { checked: string, default: string, onHover?: string };
    border: string;
    text: { checked: string, default: string, onHover?: string };
}

export interface ChipButtonTextColor {
    default: string;
    checked: string;
}

export interface ChipButtonProps {
    label?: string;
    disabled?: boolean;
    onChange?: (value: boolean) => void;
    accentColor?: string;
    color: ChipButtonColor;
    checked?: boolean;
    icon?: string;
    fitParent?: boolean;
    borderRadius?: string;
    dontShowBorder?: boolean;
    hovered?: boolean;
    height?: string;
    margin?: string;
    showAccentCircle?: boolean;
}

export interface ChipButtonState {
    hovered: boolean;
    animate: boolean;
}

export class ChipButton extends React.Component<ChipButtonProps, ChipButtonState> {

    constructor(props) {
        super(props);
        this.state = {
            hovered: false,
            animate: false,
        };
        delay(10).then(
            () => this.setState({
                ...this.state,
                animate: true,
            })
        );
    }

    public render() {

        return (
            <div
                onClick={this.buttonClicked}
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
                className="chip fit-parent"
                style={{
                    cursor: this.props.disabled ? "not-allowed" : "pointer",
                    backgroundColor: this.props.checked ? this.props.color.background.checked : this.props.color.background.default,
                    color: this.props.checked ? this.props.color.text.checked : this.props.color.text.default,
                    border: "1px solid " + (this.props.checked ? "transparent" : this.props.color.border),
                    borderRadius: this.props.borderRadius ? this.props.borderRadius : 3,
                    padding: "0 6px",
                    fontWeight: this.props.checked && !this.props.disabled ? 600 : 200,
                    margin: this.props.margin ?? "5px",
                    width: "fit-content",
                    minHeight: "var(--second-level-tabbar-button-height)"
                }}
            >
                {this.props.showAccentCircle !== false ? <div
                    style={{
                        borderRadius: "100%",
                        // border: "1px solid " + this.props.accentColor,
                        background: this.props.accentColor,
                        height: this.props.height ? this.props.height : 15,
                        width: 15,
                        margin: "auto 5px auto 0",
                        padding: 3,
                        filter: this.props.checked ? "brightness(0.92)" : null,
                        userSelect: "none",
                    }}
                >
                    {/*<img
                        src={"./images/buttons/icon-apply.png"}
                        style={{
                            width: "inherit",
                            alignSelf: "center",
                            animation: "scale-up-center 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both",
                            display: !this.props.disabled && this.props.checked ? "unset" : "none",
                        }}
                    />*/}
                    <img
                        src={this.props.disabled
                            ? "./images/buttons/icon-forbidden.png"
                            : this.props.icon}
                        style={{
                            width: "inherit",
                            alignSelf: "center",
                            // visibility: this.props.checked && this.state.animate  ? "inherit" : "hidden",
                            filter: this.props.checked ? "brightness(0.2)" : null,
                            animation: "scale-up-center 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both",
                            display: !(!this.props.disabled && this.props.checked) ? "unset" : "none",
                        }}
                    />
                </div> : null}
                <div className="chip-content-wrapper">
                    <div className="content">
                        {this.props.label}
                    </div>
                </div>
            </div>
        );
    }

    private onMouseLeave = (_) => {
        this.setState({
            hovered: false,
        });
    }

    private onMouseEnter = (_) => {
        if (this.props.hovered === undefined) {
            this.setState({
                hovered: true,
            });
        }
    }

    private buttonClicked = (e) => {
        this.setState({
            ...this.state,
            animate: false,
        }, () => {
            if (!this.props.disabled && this.props.onChange) {
                this.props.onChange(!this.props.checked);
            }
            this.setState({
                ...this.state,
                animate: true,
            })
        });
    }
}
